<template>

    <header class="header">
        <div class="header-content">
            <div class="header-logo" @click="$router.push('/')">
                <span class="header-logo-badge">OA</span>
                <span class="header-logo-text">OaitsTools</span>
            </div>
            <nav class="header-menu">
                <IconText v-for="item in visible_menu_items" :key="item.id" :title="item.title" :icon="item.icon" :url="item.url" class="header-menu-item"/>
            </nav>
            <div class="header-actions">
                <button type="button" class="header-theme" @click="toggleTheme()" :aria-label="is_dark ? 'Включить светлую тему' : 'Включить тёмную тему'">
                    <AppIcon :name="is_dark ? 'sun' : 'moon'" class="header-theme-icon"/>
                </button>
                <button v-if="!isUserAuthenticated" type="button" class="header-auth" @click="$router.push('/auth')">
                    Войти
                </button>
                <button v-else type="button" class="header-user" @click="$router.push('/settings')">
                    <span class="header-user-avatar">{{ userInitial }}</span>
                    <span class="header-user-name">{{ userName }}</span>
                </button>
            </div>
        </div>
    </header>

</template>


<script>

import IconText from './IconText.vue';
import AppIcon from './AppIcon.vue';
import { checkAuth, getLogin } from '@/auth/auth.js';
import { storage } from '@/services/storage.js';

export default {
    name: 'HeaderUI',

    components: {
        IconText,
        AppIcon
    },

    data() {
        return {
            is_dark: false
        }
    },

    created() {
        this.is_dark = document.documentElement.classList.contains('dark');
    },

    computed: {
        isUserAuthenticated() {
            return checkAuth();
        },
        visible_menu_items() {
            // Закрытые инструменты показываем в меню только авторизованным
            return this.menu_items.filter((item) => {
                return !item.private || this.isUserAuthenticated;
            });
        },
        userName() {
            return getLogin() || 'Профиль';
        },
        userInitial() {
            const name = this.userName || '?';
            return name.charAt(0).toUpperCase();
        },
    },

    methods: {
        toggleTheme() {
            this.is_dark = !this.is_dark;

            document.documentElement.classList.toggle('dark', this.is_dark);

            storage.set('theme', this.is_dark ? 'dark' : 'light');

            const meta = document.querySelector('meta[name="theme-color"]');

            if (meta) {
                meta.setAttribute('content', this.is_dark ? '#09090b' : '#fafafa');
            }
        },
    },

    props:{
        menu_items: {
            type: Array,
            default: () => [
                {
                    id: 1,
                    title: 'Инвентаризация IT',
                    icon: 'inv',
                    url: '/inv',
                    private: true
                },
                {
                    id: 2,
                    title: 'Генератор',
                    icon: 'generator',
                    url: '/gen',
                    private: true
                },
                {
                    id: 3,
                    title: 'Дашборд',
                    icon: 'dash',
                    url: '/dash',
                    private: true
                }
            ]
        },

    },
}

</script>


<style scoped>

.header{
    position: sticky;
    top: 0;
    z-index: 50;

    width: 100%;

    background: var(--header-bg);
    -webkit-backdrop-filter: blur(8px);
    backdrop-filter: blur(8px);
    border-bottom: 1px solid var(--border);
}

.header-content{
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;

    width: 85%;
    max-width: 1100px;
    height: 60px;
    margin: 0 auto;
}

.header-logo{
    display: inline-flex;
    align-items: center;
    gap: 10px;

    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
}

.header-logo-badge{
    display: inline-flex;
    align-items: center;
    justify-content: center;

    width: 30px;
    height: 30px;

    background: var(--primary);
    color: var(--primary-foreground);
    border-radius: 8px;

    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.02em;
}

.header-logo-text{
    font-size: 16px;
    font-weight: 600;
    letter-spacing: -0.01em;
    color: var(--foreground);
}

.header-menu{
    display: flex;
    align-items: center;
    gap: 4px;
}

.header-menu-item{
    color: var(--muted-foreground);
    font-weight: 500;
}

.header-menu-item:hover{
    color: var(--foreground);
}

.header-actions{
    display: flex;
    align-items: center;
    gap: 8px;
}

.header-theme{
    display: inline-flex;
    align-items: center;
    justify-content: center;

    width: 34px;
    height: 34px;

    background: transparent;
    border: 1px solid var(--border);
    border-radius: 8px;
    color: var(--muted-foreground);

    cursor: pointer;

    transition: background-color 0.15s ease, color 0.15s ease;
}

.header-theme:hover{
    background: var(--muted);
    color: var(--foreground);
}

.header-theme-icon{
    width: 16px;
    height: 16px;
}

.header-auth{
    display: inline-flex;
    align-items: center;

    height: 34px;
    padding: 0 14px;

    background: var(--primary);
    color: var(--primary-foreground);
    border: 1px solid transparent;
    border-radius: 8px;

    font-family: inherit;
    font-size: 13px;
    font-weight: 500;

    cursor: pointer;

    transition: background-color 0.15s ease;
}

.header-auth:hover{
    background: var(--primary-hover);
}

.header-user{
    display: inline-flex;
    align-items: center;
    gap: 8px;

    height: 34px;
    padding: 0 10px 0 4px;

    background: transparent;
    border: 1px solid var(--border);
    border-radius: 999px;

    font-family: inherit;

    cursor: pointer;

    transition: background-color 0.15s ease;
}

.header-user:hover{
    background: var(--muted);
}

.header-user-avatar{
    display: inline-flex;
    align-items: center;
    justify-content: center;

    width: 26px;
    height: 26px;

    background: var(--muted);
    color: var(--foreground);
    border-radius: 999px;

    font-size: 12px;
    font-weight: 600;
}

.header-user-name{
    font-size: 13px;
    font-weight: 500;
    color: var(--foreground);
}

</style>
